import React from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { ModalType } from 'global/utils/ModalsHelper';
import { IMFormModal, IMInputText, OverlaySpinner } from '@insurancemenu/imenu-components-lib/dist/components';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { PRODUCT_LINES_CONTENT_MAP } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { SAVE_PROPOSAL_MODAL_TEST_ID } from '../constants';
import { BenefitsListStyled, BenefitsSectionStyled, BenefitsTitleStyled, ProductLineCardStyled } from './styles';

interface SaveProposalModalProps {
  unusedProductLineIds: ProductLineId[];
  showCrossSellPLines: boolean;
  changeProductLine: (productLineId: ProductLineId) => void;
  onSubmit: () => void;
}

const SaveProposalModal = observer(
  ({ unusedProductLineIds, showCrossSellPLines, changeProductLine, onSubmit }: SaveProposalModalProps): JSX.Element => {
    const {
      saveProposalModalStore: { showSaveProposalModal, saveForm, loading, closeSaveProposalModal },
    } = useRootStore();

    return (
      <IMFormModal
        formId={SAVE_PROPOSAL_MODAL_TEST_ID}
        title="Save Proposal"
        subtitle="Please input the name you want to save the proposal with."
        show={showSaveProposalModal}
        formController={saveForm}
        showCloseButton={false}
        modalType={ModalType.CREATION}
        onClose={closeSaveProposalModal}
        onSubmit={onSubmit}
        formContent={
          <>
            <IMInputText label="Proposal Name" name="name" $size="full" />
            {unusedProductLineIds.length > 0 && showCrossSellPLines && (
              <BenefitsSectionStyled>
                <BenefitsTitleStyled>Don’t forget to add</BenefitsTitleStyled>
                <BenefitsListStyled>
                  {unusedProductLineIds.map((pLineId) => (
                    <ProductLineCardStyled
                      key={pLineId}
                      pLineId={pLineId}
                      onCardClick={() => {
                        changeProductLine(pLineId);
                        closeSaveProposalModal();
                      }}
                      icon={PRODUCT_LINES_CONTENT_MAP[pLineId].icon('4rem')}
                      label={PRODUCT_LINES_CONTENT_MAP[pLineId].label}
                    />
                  ))}
                </BenefitsListStyled>
              </BenefitsSectionStyled>
            )}
            <OverlaySpinner display={loading} />
          </>
        }
      />
    );
  },
);

export default SaveProposalModal;
